export default "__VITE_ASSET__DQbuirD7__"